import { useFormContext } from 'react-hook-form';
import { fields } from '../../constants';
import { useCreativeContext } from '../../hooks/useCreativeContext';

export const useByVASTTag = ({ onCreate, onSubmit }) => {
  const form = useFormContext();
  const { toggleAssignCreative } = useCreativeContext();

  const { watch, getFieldState, formState, getValues, resetField, setError } = form;

  const tags = watch(fields.vastTags.path);

  const state = getFieldState(fields.vastTags.path);

  const handleCreate = async () => {
    const { createdTags, errors } = await onCreate(getValues(fields.vastTags.path));

    // Handle errors
    errors.forEach(error => {
      setError(`${fields.vastTags.path}.${error.index}.${error.field}`, {
        type: 'manual',
        message: error.message
      });
    });

    // Handle successfully created tags
    if (createdTags.length > 0) {
      createdTags.forEach(item => {
        toggleAssignCreative(item);
      });

      // Remove only successfully created tags from the form
      const remainingTags = getValues(fields.vastTags.path).filter((_, index) =>
        !errors.some(error => error.index === index)
      );

      if (remainingTags.length === 0) {
        resetField(fields.vastTags.path);
      } else {
        form.setValue(fields.vastTags.path, remainingTags);
      }

      // Call onSubmit only if there is at least one successfully created tag
      onSubmit();
    }
  };

  return {
    disabled: state.invalid || formState.isSubmitting,
    create: handleCreate,
    creativeByVastTagDraft: tags,
  };
};
